// extracted by mini-css-extract-plugin
export var indeterminate = "_26-5";
export var md = "_26-4";
export var semantic = "_26-6";
export var sm = "_26-3";
export var text = "_26-7";
export var toggleInput = "_26-0";
export var toggleSwitch = "_26-1";
export var xs = "_26-2";